/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
import type { BaseResponseDto_AnyResponseDto } from '../models/BaseResponseDto_AnyResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CService {
  /**
   * 分类列表
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerCategories(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/categories',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 产品列表
   * @param category
   * @param pn
   * @param rn
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerProducts(
    category: string,
    pn: number,
    rn: number
  ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/products',
      query: {
        category: category,
        pn: pn,
        rn: rn,
      },
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 产品详情
   * @param id
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerProduct(
    id: number
  ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/products/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 新闻列表
   * @param pn
   * @param rn
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerNews(
    pn: number,
    rn: number
  ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/news',
      query: {
        pn: pn,
        rn: rn,
      },
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 新闻详情
   * @param id
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerNewsDetail(
    id: number
  ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/news/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 轮播列表
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerBanners(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/banners',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 首页配置
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerHome(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/home',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 产品配置
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerProductConfig(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/product-config',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 关于我们
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerAbout(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/about',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 联系我们
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerContact(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/contact',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 常见问题
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerFaq(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/faq',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
  /**
   * 站点配置
   * @returns BaseResponseDto_AnyResponseDto 获取成功
   * @throws ApiError
   */
  public static cmsControllerSiteConfig(): CancelablePromise<BaseResponseDto_AnyResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client/cms/site-config',
      errors: {
        400: `参数错误`,
        401: `未授权`,
        403: `禁止访问`,
        404: `资源不存在`,
        500: `服务器内部错误`,
      },
    });
  }
}
